import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { DSSCalendar as DSSCalendarComponent } from "src/components/pages/Settings/AdvancedFeatures/DSSCalendar/DSSCalendar";
import { PageContainer } from "src/styled";

const DSSCalendar = () => {
  return (
    <PageContainer>
      <Breadcrumbs />
      <DSSCalendarComponent />
    </PageContainer>
  );
};

export default DSSCalendar;
